import { render, staticRenderFns } from "./wikiList.vue?vue&type=template&id=6e7f435a&scoped=true"
import script from "./wikiList.vue?vue&type=script&lang=js"
export * from "./wikiList.vue?vue&type=script&lang=js"
import style0 from "./wikiList.vue?vue&type=style&index=0&id=6e7f435a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7f435a",
  null
  
)

export default component.exports